import classNames from 'classnames';
import { FC, ReactElement, TextareaHTMLAttributes, useMemo } from 'react';
import Skeleton from 'react-loading-skeleton';
import Text, { TEXT } from '../../Text/Text';
import { localeStore } from '~/mobx/localesStore';
import { IValidation } from '~/types/main';
import './style.scss';

interface IProps extends React.DetailedHTMLProps<TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement> {
  loading?: boolean;
  validation?: IValidation;
  className?: string;
  textAreaClassName?: string;
}

const Textarea: FC<IProps> = ({ loading, validation, placeholder, className, textAreaClassName, ...props }: IProps): ReactElement => {
  const _textAreaClassName = useMemo((): string => {
    return classNames('textarea', 'scrollable-block__scroll_small', { 'input-error': validation && !validation.isValid }, textAreaClassName);
  }, [validation, textAreaClassName]);

  return (
    <div className={classNames('textarea__wrapper', className)}>
      {loading ? (
        <Skeleton className={_textAreaClassName} />
      ) : (
        <>
          {/* eslint-disable-next-line react/jsx-props-no-spreading */}
          <textarea {...props} placeholder={placeholder || localeStore.t('Value')} className={_textAreaClassName} />
          {validation && !validation.isValid && validation.errorText ? <Text type={TEXT.ERROR} text={validation.errorText} /> : null}
        </>
      )}
    </div>
  );
};

export default Textarea;
